import { useEffect } from "react";

import useStore from "core/custom-hooks/useStore";
import { setT } from "core/store/actionCreators";

import * as Utils from "core/common/utils";
import { T_RESOURCES_STORAGE_KEY } from "core/common/constants/localstorage";

export default function useT() {
    const inStorage = !!sessionStorage.getItem(T_RESOURCES_STORAGE_KEY);

    const { dispatch, tRepository, state } = useStore();
    const { T } = state;

    useEffect(() => {

        const loadT = () => {

            Utils.loadingWrapper(dispatch, async () => {

                const response = await tRepository.get();

                if (response) {
                    const { data } = response;

                    if (Utils.isSuccessfulRequest(dispatch, data, false)) {

                        const { data: responseItem } = data;

                        const stringified = JSON.stringify(responseItem);

                        sessionStorage.setItem(T_RESOURCES_STORAGE_KEY, stringified);

                        dispatch(setT(responseItem));

                        console.debug("T-resources are stored and dispached");
                    }
                }
            });
        }

        if (!inStorage) {

            loadT();

        } else {

            const parsed = JSON.parse(sessionStorage.getItem(T_RESOURCES_STORAGE_KEY))

            dispatch(setT(parsed));

            console.debug("T-resources dispached");
        }

        // eslint-disable-next-line 
    }, [inStorage])

    return {
        ready: !!T
    };
}